import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 新增成员
import AddStaff from '../modal/add-staff';
// 新建权限组
import CreateAuthor from '../modal/create-author';
// 接口api
import { managerList, groupList, managerDelete } from 'api/settings';
import staffSearch from '_c/staff-search';
import Pagination from '_c/pagination';
export default {
  components: {
    AddStaff: AddStaff,
    CreateAuthor: CreateAuthor,
    staffSearch: staffSearch,
    Pagination: Pagination
  },
  data: function data() {
    return {
      formData: {
        page: 1,
        page_size: 20,
        group_id: '',
        staff_id: '',
        sort: '',
        dir: ''
      },
      currentGroup: {},
      options: [],
      tableData: {
        count: 0,
        data: []
      }
    };
  },
  computed: {
    modifyState: function modifyState() {
      return !this.formData.group_id;
    }
  },
  created: function created() {
    this.handleGroupList();
    this.handlerGroupStaffList(1);
  },
  methods: {
    // 选择员工信息
    staffChange: function staffChange(val) {
      this.formData.staff_id = val.staff_id;
    },
    // 弹窗展示-管理权限组
    openCreate: function openCreate(type, data) {
      // val 1管理权限组 0新建权限组 2编辑
      this.$router.push({
        path: '/settings/author/authorsEdit',
        query: {
          type: type,
          group_id: data === null || data === void 0 ? void 0 : data.group_id
        }
      });
    },
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.formData.sort = prop;
      this.formData.dir = order;
      this.handlerGroupStaffList(1);
    },
    // 弹窗展示-新增成员
    openAdd: function openAdd(row) {
      this.$refs.add.init(row, this.options);
    },
    // 移除确认
    handlerremoveStaff: function handlerremoveStaff(row) {
      var _this = this;
      this.$confirm(this.$t('i18n.99fc4ab919b64fa1b360b18abed189f2', {
        name: row.staff_name
      }), this.$t('i18n.ea74feecf8d74281abec3db8c9028d2b'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        managerDelete({
          privilege_manager_id: row.privilege_manager_id
        }).then(function () {
          _this.handlerGroupStaffList(1);
          _this.$message({
            type: 'success',
            message: _this.$t('886')
          });
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.page_size = val;
      this.handlerGroupStaffList(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.handlerGroupStaffList(val);
    },
    // 列表数据
    handleGroupList: function handleGroupList() {
      var _this2 = this;
      groupList().then(function (res) {
        _this2.options = res.data;
      });
    },
    // 权限组员工列表
    handlerGroupStaffList: function handlerGroupStaffList(page) {
      var _this3 = this;
      this.formData.page = page;
      managerList(this.formData).then(function (_ref2) {
        var data = _ref2.data;
        _this3.tableData = data;
        _this3.$nextTick(function () {
          _this3.$refs.tableList && _this3.$refs.tableList.doLayout();
        });
      });
    }
  }
};